import { render } from "./TableCellComponent.vue?vue&type=template&id=1c598e3d&scoped=true"
import script from "./TableCellComponent.vue?vue&type=script&lang=js"
export * from "./TableCellComponent.vue?vue&type=script&lang=js"

import "./TableCellComponent.vue?vue&type=style&index=0&id=1c598e3d&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c598e3d"]])

export default __exports__